import { atom } from 'jotai/vanilla';
import { IComponent } from '../interfaces';
import answers from './answers';

const message = atom('');

const check = atom(null, (get, set) => {
  const list = get<IComponent[]>(answers.get_data);
  const new_message = list.reduce<string>((acc, { required, answer, error, show }) => {
    if (!show) return acc; // Don't show error if component is hidden
    if (acc !== '') return acc; // Already has error
    if (error) return 'Please address the above issues.';
    if (required && !answer && show) {
      return 'Please fill out all required fields.';
    }
    return '';
  }, '');
  set(message, new_message);
  return new_message;
});

export default {
  message,
  check,
};
